import Scale from './Scale';
export default Scale;
